"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeSourceMap = void 0;
const source_map_1 = require("source-map");
let initialized = false;
exports.initializeSourceMap = () => {
    if (!initialized) {
        initialized = true;
        source_map_1.SourceMapConsumer.initialize({
            'lib/mappings.wasm': 'https://unpkg.com/source-map@0.7.3/lib/mappings.wasm',
        });
    }
};

//# sourceMappingURL=initializeSourceMap.js.map
